// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TerceraButtonStyle;
(function (TerceraButtonStyle) {
    TerceraButtonStyle["Standard"] = "js-button-gray25";
    TerceraButtonStyle["Blue"] = "js-button-blue";
    TerceraButtonStyle["Red"] = "js-button-red";
    /// used in new Style
    TerceraButtonStyle["Terminal"] = "js-button-terminal";
    TerceraButtonStyle["ColorPicker"] = "js-colorpickerbutton";
})(TerceraButtonStyle || (TerceraButtonStyle = {}));
export var TerceraButtonEvents;
(function (TerceraButtonEvents) {
    TerceraButtonEvents["onMouseDown"] = "btnMouseDown";
    TerceraButtonEvents["onClick"] = "btnClick";
    TerceraButtonEvents["onHover"] = "btnHover";
    TerceraButtonEvents["onLeave"] = "btnLeave";
    TerceraButtonEvents["onColorChanged"] = "onColorChanged";
    TerceraButtonEvents["onPairColorChanged"] = "onPairColorChanged";
})(TerceraButtonEvents || (TerceraButtonEvents = {}));
